import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-user-status',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.scss']
})
export class UserStatusComponent {
  @Input() header: string;
  @Input() message: string;
  @Output() onClose = new EventEmitter();
  @Output() onConfirm = new EventEmitter();
  constructor() { }

  /**
   * @description method use for emit closing popup event
   *
   * @memberof UserStatusComponent
   */
  public closePopup(): void {
    this.onClose.emit();
  }

  /**
   * @description method use for emit event to show confirm popup event
   *
   * @memberof UserStatusComponent
   */
  public confirm(): void {
    this.onConfirm.emit();
  }
}
